export default __webpack_public_path__ + "static/media/ill-no-data.672bf165.svg";